import { Outlet, useNavigate } from 'react-router-dom';
import { AppState, Auth0Provider } from '@auth0/auth0-react';
import { ConsentManager } from 'modules/consent-manager';
import { ContentCardsProvider } from 'modules/content-cards-feed';
import { BrazeProvider } from 'modules/push-notification';
import { UnleashContextProvider } from 'modules/unleash';
import { env } from '../../../constants';

const API_AUDIENCE = env.VITE_API_BASE_URL;

export const Auth0ProviderWithNavigate = () => {
  const navigate = useNavigate();

  const onRedirectCallback = (appState?: AppState): void => {
    navigate(appState?.returnTo ?? window.location.pathname);
  };

  return (
    <Auth0Provider
      domain={env.VITE_AUTH_DOMAIN}
      clientId={env.VITE_AUTH_CLIENT_ID}
      authorizationParams={{
        audience: API_AUDIENCE,
        redirect_uri: window.location.origin,
        scope: 'openid profile email offline_access'
      }}
      onRedirectCallback={onRedirectCallback}
      useRefreshTokens={true}
      cacheLocation="localstorage"
    >
      <UnleashContextProvider>
        <BrazeProvider>
          <ContentCardsProvider>
            <ConsentManager>
              <Outlet />
            </ConsentManager>
          </ContentCardsProvider>
        </BrazeProvider>
      </UnleashContextProvider>
    </Auth0Provider>
  );
};
